import React, { Component } from 'react';

import LanguageSelector from '../../components/button/LanguageSelector';

class PageTitleHome extends Component {
    constructor() {
        super();
        this.state = {
            lang: 'En',
        };

        this.onChangeValue = this.onChangeValue.bind( this );
    };

    onChangeValue( event ) {
        this.setState( {
            lang: event.target.title,
        } );
    };

    render() {
        return (
            <section id="page-title" className="block" style={ { backgroundImage: `url( ${ require( '../../assets/img/placeholder/volvo1.jpg' ) } )` } }>
                <div className="wrapper h-100">
                    <div className="d-flex justify-content-between position-relative h-100">
                        <div className="align-self-center">
                            <div className="title">
                                <h2>Zanesljiv partner <br/>v prometu</h2>
                            </div>

                            <p className="spacer p-top-lg mb-0">Kvaliteten in zanesljiv notranji ter mednarodni transport različnih vrst tovora. <br/> Vrste prevozov: </p>
                            <p></p>
                                <ul>
                                    <li style={{color:"wihte"}}>volumenski prevozi, </li>
                                    <li>nakladi kompletnih pošiljk, </li> 
                                    <li>zbirni prevozi.</li>
                                </ul>
                        </div>

                        {/* <div className="lang-position">
                            <nav className="languages">
                                <ul className="nav" onClick={ this.onChangeValue }>
                                    <LanguageSelector title="En" className={ this.state.lang === 'En' ? 'current-lang' : '' } />
                                    <LanguageSelector title="Ru" className={ this.state.lang === 'Ru' ? 'current-lang' : '' } />
                                    <LanguageSelector title="Lt" className={ this.state.lang === 'Lt' ? 'current-lang' : '' } />
                                </ul>
                            </nav>
                        </div> */}
                    </div>
                </div>

                <div className="page-title-bg-color"></div>
            </section>
        );
    };
};

export default PageTitleHome;
